<template>
  <DashboardPage>
    <CompanyCompanyGroup :id="route.params.id" />
  </DashboardPage>
</template>

<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue';

import CompanyCompanyGroup from './components/CompanyCompanyGroup.vue';
const route = useRoute()
</script>